import React, { memo, useCallback } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";

function CartItems({ item }) {
  const { updateQuantity, removeItem } = useCart();

  const {
    _id,
    thumbnail: image,
    slug,
    title,
    variantName,
    quantity,
    price,
    mrp,
  } = item;

  const numPrice = Number(price);
  const numMrp = Number(mrp);

  const handleRemove = useCallback(() => {
    removeItem(_id);
  }, [removeItem, _id]);

  const handleQuantityChange = useCallback(
    (delta) => {
      const newQuantity = quantity + delta;
      if (newQuantity < 1) return;

      console.log(newQuantity);
      updateQuantity(_id, newQuantity);
    },
    [updateQuantity, _id, quantity],
  );

  return (
    <>
      <div className="custom-cart-item d-flex border-bottom">
        <div className="cart-item-image-wrapper">
          <Link to={`/shop/${slug}`}>
            <img src={image} className="cart-item-img me-3" alt="Cart Item" />
          </Link>
        </div>
        <div className="flex-grow-1">
          <div className="d-flex justify-content-between align-items-start">
            <Link to={`/shop/${slug}`} className="cart-item-title">
              {title}
            </Link>
            <i
              className="icon icon-close remove fs-12"
              onClick={handleRemove}
            />
          </div>
          <div className="info-variant">{variantName}</div>
          <p className="price-wrap text-sm fw-medium">
            <span className="cart-item-price mb-2">
              ₹{numPrice.toFixed(2)}/-
            </span>
            {!isNaN(numMrp) && numMrp > numPrice && (
              <span className="old-price text-decoration-line-through text-dark-1 p-2">
                ₹{numMrp.toFixed(2)}/-
              </span>
            )}
          </p>
          <div>
            <div className="d-flex justify-content-between align-items-center mt-2">
              <div className="cart-bottom-row">
                <div className="qty-box">
                  <button onClick={() => handleQuantityChange(-1)}>-</button>
                  <span>{quantity}</span>
                  <button onClick={() => handleQuantityChange(+1)}>+</button>
                </div>

                <span className="item-total">
                  ₹{(price * quantity).toFixed(0)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(CartItems);